import Keycloak from 'keycloak-js';
import authOptions from 'config/authOptions';

const keycloak = new Keycloak(authOptions);

export default keycloak;
